import * as React from "react";
const SvgCircle = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18" })));
export default SvgCircle;
//# sourceMappingURL=Circle.js.map